import React from 'react'

import ProfileOptions from '@/pages/Users/ProfileOptions'
import ProfileSubmissions from '@/pages/Users/ProfileSubmissions'
import ProfileProjects from '@/pages/Users/ProfileProjects'

// Visibility tab: who sees the profile, which submissions and projects show
// on it, and the little toggles for activity and achievements.
const ProfileVisibility = () => (
  <div className='space-y-10'>
    <ProfileOptions />
    <ProfileSubmissions />
    <ProfileProjects />
  </div>
)

export default ProfileVisibility
